import { useState } from 'react';
import { BlackAddIcon } from 'assets/images/countryList';
import { useCurrenciesTableListing } from 'hooks/useCurrencies';
import AddCurrencyModalForm from '../addCurrencyModal/AddCurrencyModalForm';

/**
 * Trigger que abre el modal de creación de moneda con tasa de cambio.
 */
const AddCurrencyModalTrigger = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const { mutateCurrenciesTableListing } = useCurrenciesTableListing();

  const handleOpenModal = () => {
    setFormKey(previousKey => previousKey + 1);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCurrencyCreated = async () => {
    await mutateCurrenciesTableListing();
  };

  return (
    <>
      <button type="button" className="countriesModuleAddCurrencyAction" onClick={handleOpenModal}>
        <span className="countriesModuleAddCurrencyActionIcon">
          <BlackAddIcon />
        </span>
        <span className="countriesModuleAddCurrencyActionText">Agregar moneda</span>
      </button>

      {isModalOpen && (
        <AddCurrencyModalForm
          key={formKey}
          onClose={handleCloseModal}
          onCurrencyCreated={handleCurrencyCreated}
        />
      )}
    </>
  );
};

export default AddCurrencyModalTrigger;
